import { render, staticRenderFns } from "./PreView.vue?vue&type=template&id=ed149b4a&scoped=true&"
import script from "./PreView.vue?vue&type=script&lang=js&"
export * from "./PreView.vue?vue&type=script&lang=js&"
import style0 from "./PreView.vue?vue&type=style&index=0&id=ed149b4a&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed149b4a",
  null
  
)

export default component.exports